import React, { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './techStack.css';

const tools = [
  { name: 'Figma', mark: 'Fi', detail: 'From first wireframe to the final prototype.', category: 'DESIGN & PROTOTYPING', color: '#cf98fb', featured: true },
  { name: 'React', mark: '⚛︎', detail: 'Interfaces with intention.', category: 'DEVELOPMENT', color: '#8ecfea' },
  { name: 'Supabase', mark: '↯︎', detail: 'Data, auth & connection.', category: 'BACKEND', color: '#8ddab6' },
  { name: 'Illustrator', mark: 'Ai', detail: 'Identity in every detail.', category: 'VISUAL DESIGN', color: '#efbc70' },
  { name: 'Photoshop', mark: 'Ps', detail: 'Images that tell stories.', category: 'VISUAL DESIGN', color: '#85b6e9' },
  { name: 'After Effects', mark: 'Ae', detail: 'A little movement. A lot of feeling.', category: 'MOTION', color: '#a79be9' },
  { name: 'React Native', mark: 'RN', detail: 'Experiences on the move.', category: 'MOBILE / EXPO', color: '#9fd0f0' },
  { name: 'HTML & CSS', mark: '</>', detail: 'The building blocks.', category: 'WEB FOUNDATIONS', color: '#eca89a' },
];

export default function TechStack() {
  const root = useRef(null);
  useLayoutEffect(() => {
    const media = gsap.matchMedia();
    media.add('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)', (context) => {
      const cleanups = [...root.current.querySelectorAll('.stack-tile')].map((tile) => {
        const mark = tile.querySelector('.stack-tile__mark');
        const moveX = gsap.quickTo(mark, 'x', { duration: .5, ease: 'power3' });
        const moveY = gsap.quickTo(mark, 'y', { duration: .5, ease: 'power3' });
        const move = (event) => { const box = tile.getBoundingClientRect(); moveX((event.clientX - box.left - box.width / 2) * .13); moveY((event.clientY - box.top - box.height / 2) * .13); };
        const reset = () => { moveX(0); moveY(0); };
        tile.addEventListener('pointermove', move); tile.addEventListener('pointerleave', reset);
        return () => { tile.removeEventListener('pointermove', move); tile.removeEventListener('pointerleave', reset); };
      });
      return () => cleanups.forEach((cleanup) => cleanup());
    });
    return () => media.revert();
  }, []);
  return <section className="tech-stack section-shell" aria-labelledby="stack-title" ref={root}>
    <div className="section-heading section-heading--split" data-reveal><div><span className="eyebrow">02 / MY CREATIVE TOOLKIT</span><h2 id="stack-title">Good ideas.<br /><em>The right tools.</em></h2></div><p>Design thinking meets hands-on making.<br />These are the tools I reach for to connect the two.</p></div>
    <div className="tech-stack__grid">
      {tools.map((tool, index) => <article className={`stack-tile${tool.featured ? ' stack-tile--featured' : ''}`} style={{ '--tool-color': tool.color }} key={tool.name} data-reveal>
        <div className="stack-tile__top"><span>{tool.category}</span><span>0{index + 1}</span></div>
        <div className="stack-tile__mark" aria-hidden="true">{tool.mark}</div>
        <h3>{tool.name}</h3><p>{tool.detail}</p>
        {tool.featured && <div className="stack-tile__pills"><span>Research</span><span>Wireframes</span><span>Design systems</span></div>}
      </article>)}
    </div>
    <p className="tech-stack__note" data-reveal>Beyond the tools <span>UX research · API integration · Authentication · ERD & database modelling</span></p>
  </section>;
}
